import React from "react";
import { Link } from "react-router-dom";
import { BarGraphSimple } from "../components/BarGraphSimple";
import { dateString, getChangeSinceLastElection, getParliamentSize, getPrediction, getPredictionSeats, withParty } from "../calculations/utilsV2";
import { getLastElection, styleByGroup } from "../calculations/calcV2";
import { getCoalitions, getLeftRightScore, space } from "../calculations/calculationDivsV2";

interface PredictionCountryProps {
    countryStat: CountryStat;
    short: string;
    countryRegion: string;
    isParliament: boolean;
}

export const PredictionCountryV2 = (props: PredictionCountryProps) => {
    const { countryRegion, isParliament, countryStat, short } = props;

    const prediction = getPrediction(countryStat);
    if (!prediction) { return <div /> }

    const predictionSeats = getPredictionSeats(countryStat, prediction);
    const parties = prediction.map(x => x.party);
    const groups = prediction.map(x => x.group);
    const data = prediction.map(x => x.value);
    const parliament = getParliamentSize(countryStat) ?? 0;

    const lastElection = getLastElection(countryStat);
    const lastElectionData = withParty(countryStat, lastElection);

    return <div>
        <span className="underline">
            {!isParliament && 
                <Link to={"/" + short}><span className="highlight groupNi"><img src={"flags/" + short.toLowerCase() + ".png"} alt={countryRegion} height={12} /> {short}</span>&nbsp;</Link>
            }
            seats
        </span>
        <div className="margin12">
            {
                predictionSeats.filter(x => x.value > 0).map(x => <span key={x.party} className={"highlight " + styleByGroup(x.group)}>{x.group}: {x.value}</span>)
            }
            &nbsp;|&#32;{getLeftRightScore(predictionSeats)}&nbsp;|&#32;<span className="highlight groupNi">last&nbsp;update:&nbsp;{dateString(new Date(countryStat.Polls[0].DateTo))}</span>
        </div>

        {isParliament &&
        <>
            <span className="underline">coalitions</span>
            {getCoalitions(predictionSeats, parliament, countryStat.Governments[0])}
        </>
        }


        {isParliament && 
        <>
            <span className="underline">last election ({lastElection.Year})</span>
            <div className="margin12">
                {lastElectionData.sort((a, b) => b.value - a.value)
                    .map(x => <span key={x.party}><span className={"highlight " + styleByGroup(x.group)}>{x.group}:&nbsp;{x.value}%</span>{space}</span>)}
            </div>
            <span className="underline">change since last election</span>
            <div className="margin12">
                {getChangeSinceLastElection(countryStat, prediction).map((x, i) => <span key={x.party}><span className={"highlight " + styleByGroup(x.group)}>{x.group}:&nbsp;{x.value > 0 ? '+' : ''}{x.value}%</span>{space}</span>)}
            </div>
        </>
        }

        <BarGraphSimple title={countryRegion + ' election prediction'} 
            labels={parties} dataNow={data} groups={groups} />
    </div>
}